import type { FunctionComponent, ReactNode } from "react";
import { cn } from "./cn";

export interface SkeletonProps {
  /** Pulse animation. */
  active?: boolean;
  /** Title bar (default true). */
  title?: boolean;
  /** Paragraph lines (default 3), or false to hide them. */
  paragraph?: boolean | { rows?: number };
  /** With children: render the placeholder while true, the children otherwise. Default true. */
  loading?: boolean;
  children?: ReactNode;
  className?: string;
}

const BAR_CLASS = "h-4 rounded bg-noa-hover";

/** Content placeholder (antd `Skeleton` replacement): a title bar and paragraph lines. */
export const Skeleton: FunctionComponent<SkeletonProps> = ({
  active,
  title = true,
  paragraph = true,
  loading = true,
  children,
  className,
}) => {
  if (!loading) return <>{children}</>;

  const rows = paragraph === false ? 0 : ((paragraph === true ? undefined : paragraph.rows) ?? 3);

  return (
    <div className={cn("w-full", active && "animate-pulse", className)} aria-busy="true">
      {title && <div className={cn(BAR_CLASS, "w-[38%]")} />}
      {rows > 0 && (
        <div className={cn("flex flex-col gap-4", title && "mt-7")}>
          {Array.from({ length: rows }, (_, index) => (
            <div key={index} className={cn(BAR_CLASS, index === rows - 1 && rows > 1 ? "w-[61%]" : "w-full")} />
          ))}
        </div>
      )}
    </div>
  );
};
